import React, { useState, useEffect } from "react";
import {
  getSIngleActiveModule,
  putSIngleActiveModule,
} from "../../services/ActivePrograms";
import { IoArrowBack } from "react-icons/io5";
import { BlogEditorComponent } from "../blog/BlogEditor";
import {
  getFileExtinsion,
  getFileName,
  isEmpty,
  showToastError,
  showToastSuccess,
} from "../../Utils/Helper";
import {
  getUploadFileCategory,
  uploadFile,
} from "../../services/FileUploadService";
import { FaRegEdit } from "react-icons/fa";
const ActiveModuleEdit = (props) => {
  const [module, setModule] = useState(null);
  const [isLoading, setLoader] = useState(true);
  const [isSubmit, setSubmit] = useState(false);
  const [moduleName, setModuleName] = useState("");
  const [moduleContent, setModuleContent] = useState("");
  const [description, setDescription] = useState("");
  const [CoverShowImageCreate, setCoverShowImageCreate] = useState("");
  const [getSingleModule, setSIngleGetModule] = useState([]);

  const [CoverShowImage, setCoverShowImage] = useState("");
  const [error, setError] = useState({
    moduleContent: false,
  });
  const [attachmentList, setAttachmentList] = useState([]);
  const [existList, setExistList] = useState([]);

  useEffect(() => {
    getSIngleModuleById(props.moduleId);
  }, [props.moduleId]);

  const getSIngleModuleById = async (ModuleId) => {
    setLoader(true);
    try {
      if (!ModuleId) {
        return;
      }
      const response = await getSIngleActiveModule(props.programId, ModuleId);
      if (response.status === 200 && response.data) {
        const module = response.data.data[0];
        console.log(module, "module");
        setModuleContent(module.content);
        setSIngleGetModule(module);
        setModuleName(module.title);
        setDescription(module.description);
        setExistList(module.attachments);
        setCoverShowImage(module.image);
        setModule(module);
      } else {
        console.log(response?.data || response.message);
      }
      setLoader(false);
    } catch (error) {
      error?.data?.data &&
        console.log(error?.data?.data || error.data?.message);
      setLoader(false);
    }
  };
  const checkValidation = () => {
    try {
      let isValid = true;
      let error = {};

      if (!CoverShowImageCreate && !CoverShowImage) {
        isValid = false;
        error = { ...error, image: true };
      }
      if (!moduleName || isEmpty(moduleName)) {
        isValid = false;
        error = { ...error, name: true };
      }

      if (!description || isEmpty(description)) {
        isValid = false;
        error = { ...error, description: true };
      }

      if (!moduleContent || moduleContent === "<p><br></p>") {
        isValid = false;
        error = { ...error, moduleContent: true };
      }

      setError(error);
      return isValid;
    } catch (error) {}
  };
  const instandDn = (dt) => {
    const a = document.createElement("a");
    document.body.appendChild(a);
    var url = URL.createObjectURL(dt);
    a.href = url;
    a.download = dt.name;
    a.target = "_blank";
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  };
  const renderError = (msg, value, style) => {
    return value ? (
      <h6
        className="text-danger error"
        style={{ marginBottom: 15, marginTop: -15, ...style }}
      >
        {msg}
      </h6>
    ) : null;
  };

  const handleSubmitModule = async (e) => {
    e.preventDefault();
    if (!checkValidation()) {
      return;
    }
    setSubmit(true);
    var parms = {};
    parms["title"] = moduleName;
    parms["description"] = description;
    parms["content"] = moduleContent;
    parms["order"] = getSingleModule.order;

    try {
      let el = [];
      let documentName = [];
      documentName = attachmentList.map(
        (it) => getFileName(it) + "." + getFileExtinsion(it)
      );
      const imageName = CoverShowImageCreate
        ? getFileName(CoverShowImageCreate) +
          "." +
          getFileExtinsion(CoverShowImageCreate)
        : null;
      CoverShowImageCreate &&
        (await uploadFile(
          CoverShowImageCreate,
          getUploadFileCategory.moduleImage,
          imageName,
          props.programId
        ));
      attachmentList.map(
        async (it, i) =>
          await uploadFile(
            it,
            getUploadFileCategory.moduleDoc,
            documentName[i],
            props.programId
          )
      );

      el = existList?.map((dt) => dt.split("/").pop());

      const response = await putSIngleActiveModule(
        props.programId,
        props.moduleId,
        {
          ...parms,
          image: imageName ? imageName : CoverShowImage?.split("/").pop(),
          attachments: [...el, ...documentName],
          isVideoAttached: moduleContent.includes("ql-video"),
        }
      );
      setSubmit(false);
      if (response.status === 200) {
        showToastSuccess(`Active module is updated`);
        props.setEditMode(false);
      } else {
        showToastError(
          response?.data || response.message || "error occurred while updating"
        );
      }
    } catch (error) {
      setSubmit(false);
      // setShowLoader(false)
      showToastError(
        error?.data?.data ||
          error.data?.message ||
          "Some error occurred while updating"
      );
      console.log(error);
    }
  };

  return (
    <>
      {isLoading ? (
        <center>
          <div
            style={{ width: "3rem", height: "3rem", color: "#1f7e78" }}
            className="spinner-border mt-3 mb-4"
            role="status"
          />
        </center>
      ) : (
        <div className="containers">
          <form onSubmit={handleSubmitModule}>
            <div className="my-2">
              <button
                type="button"
                className="btn btn-primary btn-custom-tag py-2"
                onClick={() => props.setEditMode(false)}
              >
                <IoArrowBack /> &nbsp;&nbsp;&nbsp; Back
              </button>
            </div>
            <div className="my-4">
              <h2 className="chidHeadFont d-flex align-items-center gap-5">
                <span className="h5 mb-0" style={{ color: "#1f7e78" }}>
                  {module?.order + 1 < 10 && "0"}
                  {module?.order + 1}
                </span>
                <input
                  type="text"
                  className="form-control w-100 fw-bold bg-light"
                  value={moduleName}
                  onChange={(e) =>
                    setModuleName(e.target.value)
                  }
                />
              </h2>
            </div>
            <div className="mt-4">
              <div className="row">
                <div className="col-md-3 text-center">
                  <div className="bg-light rounded position-relative d-inline2">
                    <button
                      type="button"
                      className="btn btn-light btn-sm position-absolute"
                      style={{ top: 0, right: '20px', bottom:0,height:'fit-content',margin:'auto' }}
                    >
                      <FaRegEdit />
                    </button>

                    <img
                      src={
                        (CoverShowImageCreate !== "" &&
                          URL.createObjectURL(CoverShowImageCreate)) ||
                        (CoverShowImage !== "" && CoverShowImage) ||
                        "/images/upload_banner.png"
                      }
                      style={{ objectFit: "cover" }}
                      onError={(e) => {
                        e.target.src = "/images/defaultPlaceholder.jpg"; //replacement image imported above
                      }}
                      alt="2"
                      className="active_dummyimg module-info-thumbnail"
                    />
                    <input
                      type="file"
                      accept="image/*"
                      className="form-control uploader-input mb-5"
                      value=""
                      onChange={(e) => {
                        // setProgramImageCreate(e.target.files[0]);
                        setCoverShowImageCreate(e.target.files[0]);
                        setError({ ...error, image: false });
                      }}
                    />
                    {renderError("Please enter image", error.image, {
                      marginTop: 10,
                      marginBottom: -5,
                    })}
                  </div>
                </div>
                <div className="col-md-9">
                  <h6 className="text-muted">Module Description</h6>
                  <textarea
                    className="form-control bg-light"
                    rows={4}
                    value={description}
                    onChange={(e) =>
                      setDescription(e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 border rounded px-3 py-2 mt-4 bg-light">
              <div className="d-flex justify-content-between align-items-center ">
                <p className="whole_label resFont">
                  Module Content<span className="text-danger"> *</span>
                </p>
                <p className="whole_label resFont">
                  {moduleContent.replace(/<[^>]*>/g, "").length}/10,000
                  characters
                </p>
              </div>
              <div className="text-editor-receipe">
                <BlogEditorComponent
                  onChange={(data) => {
                    const textContent = data.replace(/<[^>]*>/g, "");
                    if (textContent.length > 10000) {
                      let charCount = 0;
                      let sliceIndex = 0;
                      const regex = /<[^>]*>|[^<]+/g;
                      const parts = data.match(regex) || [];

                      for (let i = 0; i < parts.length; i++) {
                        const part = parts[i];
                        if (!part.startsWith("<")) {
                          charCount += part.length;
                          if (charCount > 10000) {
                            const excess = charCount - 10000;
                            parts[i] = part.slice(0, -excess);
                            parts.length = i + 1;
                            break;
                          }
                        }
                        sliceIndex += part.length;
                      }
                      setModuleContent(parts.join(""));
                    } else {
                      setModuleContent(data);
                    }
                    setError({ ...error, moduleContent: false });
                  }}
                  placeholder="start writing..."
                  value={moduleContent}
                  onAddNewFile={(fileName) => {}}
                />
              </div>
              {renderError("Please add content.", error.moduleContent, {
                marginTop: -5,
              })}
            </div>
            <div className="col-md-12 position-relative px-3 py-2  mt-4 border rounded  bg-light">
              <p className="whole_label resFont">
                Upload files{" "}
                <span className="small_letter2">(.doc, .pdf, .docx)</span>
              </p>

              {/* Document Upload */}
              <div className="multi-uploader d-flex">
                {/* File Uploader */}
                <div className="uploader-input_multi me-3 bg-white">
                  <input
                    type="file"
                    className="form-control uploader-input"
                    accept="application/pdf"
                    multiple
                    onChange={(e) => {
                      setAttachmentList([
                        ...Array.from(e.target.files),
                        ...attachmentList,
                      ]);
                    }}
                    onClick={(e) => (e.target.value = null)}
                  />
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 16 16"
                    color="#1f7e78"
                    height="3rem"
                    width="3rem"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ color: "rgb(31, 126, 120)" }}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"></path>
                  </svg>
                </div>
                {/* All Attached Files */}
                {attachmentList.length > 0 &&
                  attachmentList.map((dt, i) => (
                    <div
                      className="me-3"
                      key={i}
                      style={{
                        position: "relative",
                        width: "100px",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src="/images/pdf.png"
                        alt=""
                        className="active_dummyimg_multi bg-white"
                        onClick={() => instandDn(dt)}
                      />
                      <span
                        onClick={() => {
                          let newFormValues = [...attachmentList];
                          newFormValues.splice(i, 1);
                          setAttachmentList(newFormValues);
                        }}
                        className="close-button"
                      ></span>
                      <p
                        style={{
                          width: "100%",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                        className="mb-0"
                      >
                        {dt.name}
                      </p>
                    </div>
                  ))}

                {/* All Existed Files */}
                {existList.length > 0 &&
                  existList?.map((dt, i) => (
                    <div
                      className="me-3"
                      key={i}
                      style={{
                        position: "relative",
                        width: "100px",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src="/images/pdf.png"
                        alt=""
                        className="active_dummyimg_multi"
                        onClick={() => window.open(dt, "_blank")}
                      />
                      <span
                        onClick={() =>
                          setExistList(existList.filter((it) => it !== dt))
                        }
                        className="close-button"
                      ></span>
                      <p
                        onClick={() => window.open(dt, "_blank")}
                        style={{
                          width: "100%",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                        }}
                        className="mb-0"
                      >
                        {dt?.split("/").pop()}
                      </p>
                    </div>
                  ))}
              </div>
            </div>
            <div className="d-flex justify-content-between  mt-4 ">
              <button
                type="button"
                className="btn btn-primary btn-custom-tag py-2"
                onClick={() => props.setEditMode(false)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary btn-custom py-2">
                Update Module
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default ActiveModuleEdit;
